import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface InstaMedia {
  id: string;
  caption?: string;
  media_url: string;
  media_type: string;
  permalink: string;
  timestamp: string;
  thumbnail_url?: string;
}

export interface InstagramAccount {
  id: number;
  instagram_user_id: string;
  account_type: 'PERSONAL'|'BUSINESS';
  expires_at: string;
}

@Injectable({ providedIn: 'root' })
export class InstagramApiService {

  private baseUrl = environment.production
    ? environment.serverUrl
    : environment.paymentGenetatorLinkURL;
  
  constructor(private http: HttpClient) {}

  // 3) Métodos de chamada usando baseUrl + httpOptions
  getPersonalMedia(storeId: number): Observable<InstaMedia[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };

    const url = environment.production
      ? `${environment.serverUrl}/admin/store/${storeId}/instagram/personal/media`
      : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/personal/media`;


    return this.http.get<InstaMedia[]>(url, httpOptions);
  }

  getHashtagMedia(
    storeId: number,
    tag: string
  ): Observable<{ hashtag: string; data: InstaMedia[] }> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };


    const url = environment.production
    ? `${environment.serverUrl}/admin/store/${storeId}/instagram/hashtag/${tag}/media`
    : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/hashtag/${tag}/media`;

    return this.http.get<{ hashtag: string; data: InstaMedia[] }>(url, httpOptions);
  }

  getMentionedMedia(storeId: number): Observable<InstaMedia[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };


    const url = environment.production
    ? `${environment.serverUrl}/admin/store/${storeId}/instagram/mentions/media`
    : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/mentions/media`;

    return this.http.get<InstaMedia[]>(url, httpOptions);
  }

  getTaggedMedia(storeId: number): Observable<InstaMedia[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };


    const url = environment.production
    ? `${environment.serverUrl}/admin/store/${storeId}/instagram/tags/media`
    : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/tags/media`;

    return this.http.get<InstaMedia[]>(url, httpOptions);
  }


  listAccounts(storeId: number): Observable<{accounts:InstagramAccount[]}> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };


    const url = environment.production
    ? `${environment.serverUrl}/admin/store/${storeId}/instagram/accounts`
    : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/accounts`;

    return this.http.get<{accounts:InstagramAccount[]}>(url, httpOptions);
  }

  deleteAccount(storeId: number, accountId: number): Observable<void> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
      }),
    };


    const url = environment.production
    ? `${environment.serverUrl}/admin/store/${storeId}/instagram/accounts/${accountId}`
    : `${environment.paymentGenetatorLinkURL}/admin/store/${storeId}/instagram/accounts/${accountId}`;


    return this.http.delete<void>(url, httpOptions);
  }

  getAccessToken(): string {
    return localStorage.getItem("access_token") || '';
  }
}
